import {
    BorrowerSelection,
    BorrowerType,
} from '../../../../../../../../../common/components/v2/BorrowerSelector/constants/borrowerSelection';

/** What the Borrower section needs to know about the loan being added/edited (it doesn't edit these itself). */
export interface BorrowerLoanContext {
    /** The loan was created for a B-Client, so its borrower can't be changed (its broker still can). */
    brokerAgreementLocked: boolean;
}

export const defaultBorrowerLoanContext: BorrowerLoanContext = {
    brokerAgreementLocked: false,
};

/** The BorrowerSelector's selection, plus the optional broker of a "Borrower Only" loan. */
export interface BorrowerForm extends BorrowerSelection {
    brokerId: number | undefined;
}

export const emptyBorrowerForm: BorrowerForm = {
    borrowerType: BorrowerType.Entity,
    borrowerEntityId: undefined,
    brokerAgreementId: undefined,
    brokerId: undefined,
};
